module.exports = __webpack_public_path__ + "img/blog-14-1.8c6867da.webp";